// AppRoutes.js
import React from 'react';
import { Routes, Route } from 'react-router-dom';

import {DashboardPage} from './dashboard/Dashboard';
import {JobsPage} from './jobs/Jobs';
import {CreateProjectPage} from './createProject/createproject';
import {TechnicalAnalysisPage} from './technicalAnalysis/TechnicalAnalysis';
import {DomainAnalysisPage} from './domainAnalysis/DomainAnalysis';
import {MicroserviceGenerationDashboard} from './microserviceGeneration/MicroServiceGeneration';

function PageRoutes({ user, jwtToken }) {
  return (
    <Routes>
      <Route path="/dashboard" element={<DashboardPage  jwtToken={jwtToken}/>} />
      <Route path="/jobs" element={<JobsPage  jwtToken={jwtToken}/>} />
      <Route path="/create-project" element={<CreateProjectPage  jwtToken={jwtToken}/>} />
      <Route path="/technical-analysis" element={<TechnicalAnalysisPage  jwtToken={jwtToken}/>} />
      <Route path="/domain-analysis" element={<DomainAnalysisPage  jwtToken={jwtToken}/>} />
      <Route path="/microservice-generation" element={<MicroserviceGenerationDashboard  jwtToken={jwtToken}/>} />
    </Routes>
  );
}

export default PageRoutes;